// removed by extract-text-webpack-plugin
module.exports = {"VideoPlayer":"VideoPlayer__VideoPlayer___1p3x9","VideoParent":"VideoPlayer__VideoParent___29o6z","Video":"VideoPlayer__Video___2qOdm","Icon":"VideoPlayer__Icon___HXEBt","IconRight":"VideoPlayer__IconRight___1YDYD","IconLeft":"VideoPlayer__IconLeft___hK5D1"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/VideoPlayer/VideoPlayer.less
// module id = 1217
// module chunks = 0 1